import React from 'react';
import PropTypes from 'prop-types';
import { DeleteFilled, MessageOutlined } from '@ant-design/icons';
import { Divider } from 'antd';

// import { LinkContainer } from 'react-router-bootstrap';
// // Local Deps
// import { editUserRoute } from '../../../../../config/navigation/routes';
// import trashCan from '../../../../../images/trashcan.svg';
// import edit from '../../../../../images/edit.svg';
// import EmailReset from '../EmailReset';

import './Actions.scss';

export default class Actions extends React.PureComponent {
  static propTypes = {
    cellProps: PropTypes.any.isRequired,
    selectedAction: PropTypes.func,
    fullCellProps: PropTypes.bool,
    hideDelete: PropTypes.bool,
    hideMessage: PropTypes.bool,
  };

  static defaultProps = {
    selectedAction: (action, id = null, folderName = null) => {
      console.log(action, id, folderName);
    },
    fullCellProps: false,
    hideDelete: false,
    hideMessage: false,
  };

  render() {
    const {
      cellProps,
      selectedAction,
      fullCellProps,
      hideDelete,
      hideMessage,
    } = this.props;
    return (
      <span className="actions-wrapper">
        {!hideMessage && (
          <button
            onClick={() => {
              if (fullCellProps) {
                selectedAction('reply', cellProps);
              } else {
                selectedAction('reply', cellProps.original.id);
              }
            }}
          >
            <MessageOutlined />
          </button>
        )}
        <Divider type="vertical" />

        {!hideDelete && (
          <button
            onClick={() => {
              if (fullCellProps) {
                selectedAction('delete', cellProps);
              } else {
                selectedAction('delete', cellProps.original.id);
              }
            }}
          >
            <DeleteFilled />
          </button>
        )}
      </span>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/actions/Actions.jsx